
/* eslint-disable object-property-newline */

import { mapState, mapMutations } from "vuex";
import Others from "./mixins/others";
import InterfaceLoad from "./mixins/interface-load";

/*
const verticalAlignPairs = {
    top: "self-start", center: "self-center", bottom: "self-end"
};
*/

export default {
    name: "QfComponentsRenderer",
    mixins: [Others, InterfaceLoad],
    props: {
        data: { type: Object, required: true },
        template: { type: Array, required: true },
        dataSlot: { type: String, default: null },
        parent: { type: String, default: null },
        gutter: { type: Boolean, default: true },
        path: { type: Array, default: () => [] }
    },
    data() {
        return {
            xSpace: "sm",
            ySpace: "sm",
            flexType: "row"
            // flexType: "column"
        };
    },
    computed: {
        ...mapState("main", ["currentApplicationId"]),
        ...mapState("components", [
            "indexPairs", "readOnly", "legacyElementState", "live", "designer", "components", "properties", "futureValues", "activeComponent",
            "currentInterfaceProperties", "parsed"
        ]),
        renderClasses() {
            return this.gutter ? ["col", "q-pa-md"] : ["col"];
        },
        componentClasses() {
            return ["col", this.flexType];
        }
    },
    methods: {
        ...mapMutations("components", ["addAutomatedIndex", "updateFutureValues", "setActiveComponent", "updateLegacyElementState"]),
        updateActiveComponent(guid, event) {
            if (this.designer && !this.live) {
                event.stopPropagation();
                this.setActiveComponent(guid);
            }
        },
        shareClasses(properties, isVisible) {
            const sizeClasses = isVisible ? [] : ["hidden"];

            sizeClasses.push(properties.__generics.sizeDesktop === 0 ? "col-md" : `col-md-${properties.__generics.sizeDesktop}`);
            sizeClasses.push(properties.__generics.sizeTablet === 0 ? "col-sm" : `col-sm-${properties.__generics.sizeTablet}`);
            sizeClasses.push(properties.__generics.sizePhone === 0 ? "col-xs-12" : `col-xs-${properties.__generics.sizePhone}`);

            return sizeClasses;
        },
        singleClasses(properties, isVisible) {
            const sizeClasses = isVisible ? [] : ["hidden"];

            sizeClasses.push(properties.__generics.sizeDesktop === 0 ? "col-md-12" : `col-md-${properties.__generics.sizeDesktop}`);
            sizeClasses.push(properties.__generics.sizeTablet === 0 ? "col-sm-12" : `col-sm-${properties.__generics.sizeTablet}`);
            sizeClasses.push(properties.__generics.sizePhone === 0 ? "col-xs-12" : `col-xs-${properties.__generics.sizePhone}`);

            return sizeClasses;
        },
        padding(top = 0, right = 0, bottom = 0, left = 0) {
            const padding = {};
            if (top) { padding["padding-top"] = `${top}px`; }
            if (right) { padding["padding-right"] = `${right}px`; }
            if (bottom) { padding["padding-bottom"] = `${bottom}px`; }
            if (left) { padding["padding-left"] = `${left}px`; }

            return padding;
        },
        margin(top = 0, right = 0, bottom = 0, left = 0) {
            const margin = {};
            if (top) { margin["margin-top"] = `${top}px`; }
            if (right) { margin["margin-right"] = `${right}px`; }
            if (bottom) { margin["margin-bottom"] = `${bottom}px`; }
            if (left) { margin["margin-left"] = `${left}px`; }

            return margin;
        },
        paddingAndMargin(paddingList, marginList) {
            return { ...this.padding(...paddingList), ...this.margin(...marginList) };
        }
    },
    render(h) {
        const buildDetails = (element, properties, body) => {
            const isBuild = this.designer && !this.live;
            const localPath = [...this.path, element.guid].join(",");
            const { guid } = element;
            const details = {};
            const configProperties = this.components[properties.__component];
            const reactiveMandatory = {};
            const inFragment = properties.__fragment;
            const getMapAttributes = attributes => {
                const data = { type: null, key: null };
                const { set } = attributes;

                if (set && set.startsWith("m_")) {
                    const pathList = set.substring(2).split(".");

                    if (pathList.length > 1) {
                        let cursor = this.parsed.modelClasses[pathList.splice(0, 1)[0]];

                        pathList.forEach(node => { cursor = cursor && cursor.fields ? cursor.fields[node] : null; });
                        if (cursor) {
                            data.type = cursor.type;
                            data.key = cursor.key;
                        }
                    }
                }

                return data;
            };
            let fragmentReadOnly;

            if (!this.legacyElementState.hasOwnProperty(localPath)) {
                const { display, readOnly, mandatory } = properties.__generics;
                this.updateLegacyElementState({
                    guid: localPath,
                    values: {
                        display, readOnly, mandatory, mandatoryShow: false
                    }
                });
            }

            if (inFragment) {
                const { readOnly } = this.properties[inFragment];
                fragmentReadOnly = readOnly;
            }

            Object.defineProperty(reactiveMandatory, "show", {
                enumerable: true,
                get: () => (this.legacyElementState[localPath] ? this.legacyElementState[localPath].mandatoryShow : undefined),
                set: (value) => this.updateLegacyElementState({ guid: localPath, values: { mandatoryShow: value } })
            });

            details.props = {
                name: guid,
                path: localPath,
                guid,
                events: {},
                properties: this.properties[guid],
                map: getMapAttributes(this.properties[guid]),
                data: this.data[guid],
                isMandatory: this.legacyElementState[localPath] ? this.legacyElementState[localPath].mandatory : false,
                mandatory: reactiveMandatory,
                readOnly: fragmentReadOnly || (this.legacyElementState[localPath] ? this.legacyElementState[localPath].readOnly : false)
            };

            if (isBuild) {
                const { readOnly, mandatory } = properties.__generics;
                details.props.isMandatory = mandatory;
                details.props.readOnly = fragmentReadOnly || readOnly;
            } else {
                details.props.isMandatory = this.legacyElementState[localPath] ? this.legacyElementState[localPath].mandatory : false;
                details.props.readOnly = fragmentReadOnly || (this.legacyElementState[localPath] ? this.legacyElementState[localPath].readOnly : false);
            }

            const { path } = details.props;
            const { parent } = details.props.properties;

            if (parent && path) {
                /* // ToDo - removed for hotfix with update code & changes
                const { __component, pathInsideList } = this.properties[parent];

                if (__component === "ctrl-segment-list") {
                    const [first, second] = path.split(",");
                    if (first === parent && second) {
                        details.props.idxFromList = parseInt(second, 10);
                    }
                    details.props.properties.pathInsideList = path;
                    details.props.pathInsideList = path;
                } else if (pathInsideList) {
                    details.props.pathInsideList = path;
                    details.props.properties.pathInsideList = path;
                }
                */
                details.props.properties.componentPath = path;
            }

            if (configProperties.slots) {
                const slots = [];
                (body || []).forEach((slot) => {
                    if (this.legacyElementState[slot.guid] ? this.legacyElementState[slot.guid].display : true) {
                        const newSlot = { guid: slot.guid, label: this.properties[slot.guid].label };
                        slots.push(newSlot);
                    }
                });
                details.props.slots = slots;
            }

            if (configProperties.namespace) {
                details.props.emptyBody = body ? this.__generateData(body) : {};
                details.props.template = body;
            }

            if (configProperties.values) {
                const { __events: events } = this.properties[guid];

                if (!this.futureValues.hasOwnProperty(localPath)) {
                    if (this.designer) {
                        this.updateFutureValues({
                            guid: localPath,
                            data: [
                                { value: "test1", label: "Test 1" },
                                { value: "test2", label: "Test 2" },
                                { value: "test3", label: "Test 3" }]
                        });
                    } else {
                        this.updateFutureValues({ guid: localPath, data: this.futureValues[guid] || [] });
                    }
                }

                if (events && events.onDisplayValue) {
                    const newLine = "\r\n";
                    let displayValueFn;
                    try {
                        // eslint-disable-next-line no-new-func
                        displayValueFn = new Function("data", `let value;${events.onDisplayValue};${newLine}return value;`);
                    } catch (err) {
                        // eslint-disable-next-line no-console
                        console.log(err);
                    }

                    if (displayValueFn) {
                        details.props.events.onDisplayValue = displayValueFn;
                    }
                }
                details.props.values = this.futureValues[localPath];
            }

            const { __customEvents } = this.properties[guid];
            if (__customEvents) {
                Object.entries(__customEvents).forEach(([key, value]) => {
                    if (value) {
                        try {
                            // eslint-disable-next-line no-new-func
                            details.props.events[key] = new Function("data", `${value}`);
                        } catch (err) {
                            // eslint-disable-next-line no-console
                            console.log(err);
                        }
                    }
                });
            }

            return details;
        };
        const createTemplate = tmpl => {
            const element = [];
            let lineShare = [];
            let hasVisible = false;

            tmpl.forEach(entry => {
                const properties = this.properties[entry.guid];
                const { __component } = properties;
                const localPath = [...this.path, entry.guid].join(",");
                const configProperties = this.components[properties.__component];

                const children = [];
                let body; let component; let componentVisible;
                const isFragmentDesign = this.designer && !this.live && ["ctrl-fragment"].includes(__component);

                if (entry.body && entry.body.length && !isFragmentDesign) {
                    body = entry.body;

                    if (configProperties.namespace) {
                        const componentData = this.data[entry.guid];
                        componentData.forEach((dataEntry, idx) => {
                            children.push(
                                h("qf-components-renderer", {
                                    props: {
                                        template: body,
                                        data: dataEntry,
                                        parent: entry.guid,
                                        gutter: configProperties.padding,
                                        path: [...this.path, entry.guid, idx]
                                    },
                                    // slot: `data-${idx}`
                                    slot: `${idx}`
                                }, [null])
                            );
                        });
                    } else if (configProperties.slots) {
                        (body || []).forEach(bodyEntry => {
                            children.push(
                                h("qf-components-renderer", {
                                    props: {
                                        template: [bodyEntry], data: this.data, parent: entry.guid,
                                        dataSlot: bodyEntry.guid, path: [...this.path]
                                    },
                                    slot: bodyEntry.guid
                                }, [null])
                            );
                        });
                    } else {
                        children.push(
                            h("qf-components-renderer", {
                                props: {
                                    template: body, parent: entry.guid, data: this.data,
                                    gutter: configProperties.padding, path: [...this.path]
                                }
                            }, [null])
                        );
                    }
                }

                component = h(properties.__component, buildDetails(entry, properties, body), children.length ? children : [null]);
                this.addAutomatedIndex({ componentType: properties.__component, guid: entry.guid });
                const options = {
                    class: ["component-container"],
                    attrs: {
                        "at-id": `${properties.__component}_${this.indexPairs[entry.guid]}`,
                        id: properties.__generics.idComp,
                        "path-id": component.data.props.path
                    },
                    style: this.paddingAndMargin(properties.__generics.padding || [], properties.__generics.margin || []),
                    on: {
                        click: event => {
                            if (!this.readOnly) {
                                if (!this.dataSlot) {
                                    this.updateActiveComponent(entry.guid, event);
                                }
                            }
                        }
                    }
                };

                if (this.legacyElementState[localPath]) {
                    componentVisible = this.legacyElementState[localPath].display;
                    if (!hasVisible && componentVisible) {
                        hasVisible = true;
                    }
                } else {
                    componentVisible = true;
                    hasVisible = true;
                }

                if (configProperties.slots) {
                    if (this.designer) {
                        options.key = `${this.currentInterfaceProperties.id}_${entry.guid}`;
                    } else {
                        options.key = entry.guid;
                    }
                }
                if (this.activeComponent && entry.guid === this.activeComponent) {
                    options.class.push("component-active");
                }

                component = h("div", options, [component]);
                if (properties.__generics.share) {
                    lineShare.push(h("div", {
                        class: this.shareClasses(properties, componentVisible)
                    }, [component]));
                } else {
                    if (lineShare.length) {
                        lineShare.push(h("div", {
                            class: this.shareClasses(properties, componentVisible)
                        }, [component]));
                        element.push(h("div", {
                            class: [hasVisible ? "" : "hidden", "col-12"]
                        }, [h("div", { class: "row ac-gutter-sm" }, lineShare)]));
                    } else {
                        lineShare.push(component);
                        element.push(h("div", { staticClass: "col-12 row", class: hasVisible ? "" : "hidden" }, [h("div", {
                            class: this.singleClasses(properties, componentVisible)
                        }, lineShare)]));
                    }

                    lineShare = [];
                    hasVisible = false;
                }
            });

            if (lineShare.length) {
                element.push(h("div", {
                    class: [hasVisible ? "" : "hidden", "col-12"]
                }, [h("div", { class: "row ac-gutter-sm" }, lineShare)]));
            }

            return element;
        };

        this.__initStateFromData(this.data);
        const myTemplate = this.template ? createTemplate(this.template) : null;

        return h("div", {
            class: this.renderClasses,
            on: {
                click: event => {
                    if (!this.readOnly) {
                        if (this.dataSlot) {
                            this.updateActiveComponent(this.dataSlot, event);
                        } else if (this.parent === null) {
                            this.updateActiveComponent(null, event);
                        }
                    }
                }
            }
        }, [h("div", { staticClass: "row ac-gutter-sm" }, this.template ? myTemplate : [])]);
    }
};
